export default "/fonts/Gotham-Light.otf?d8bf4f5699c6c25696c47af47f88ab7a";